import { makeStyles } from '@material-ui/core/styles'

const UnmissableStyles = makeStyles((theme) => ({
  root: {
    background: 'linear-gradient(180deg, rgba(251,245,236,1) 0%, rgba(251,245,236,1) 68%, rgba(255,255,255,1) 68%)',
  },
  loadMoreWrapper: {
    paddingTop: '9px !important',
    paddingBottom: '4px !important',
  }
}))
export default UnmissableStyles
